export var callbacks = {};